/**
 * @file
 *
 * This provides the main theme javascript for
 * TODO
 * - Add lint and format rules
 * - Modernize legacy code to ES6
 * - Update Gulp to use Rollup
 * - jQuery-to-vanilla wherever possible
 */
(($, Drupal, drupalSettings, undefined) => {
    /********************
     ** Global Variables
     ********************/
    let prevDevice = ''
    let device = ''
    let prefersReducedMotion = false

    const mq = jQuery('#js-mediaQueryReference')[0]
    const mqSupport = Modernizr.mq('only all')

    const $body = $("body")
    const $page = $("#page")

    const activeClass = 'is-active'
    const stickyClass = 'is-sticky'
    const staticClass = 'is-static'

    /********************
     ** Global constants
     ********************/

    const header = document.getElementById('header')

    const hamburgerMenuToggle = document.getElementById('hamburger')

    const hamburgerMenuExpandedClassname = 'menu--open'

    const toolbar = document.getElementById('toolbar-administration')

    /********************
    ** Blazy
    ********************/

    function initBLazy() {
      var bLazy = new Blazy({
        offset: 400,
        success: function(element, context) {
            // console.log('Blazy - Success');
        },
        error: function(element, context) {
            // console.log('Blazy - Error');
        }
      })
    }

    /********************
    ** Flickity Carousel
    ********************/

    function flickity() {
        if (!$('.carousel-container').get(0)
                && $('.carousel-container').hasClass('event-carousel'))
            return

        $('.carousel-container:not(.event-carousel)')
            .each(function(index, element) {
                let $carousel = $(element)

                $carousel.flickity({
                    cellAlign: 'right',
                    prevNextButtons: true,
                    pageDots: false,
                    arrowShape: 'M16.1.5,13.4,4.3l7.8,5.4H-.1v4.6H21.2l-7.8,5.4,2.7,3.8,13.8-9.6V10.1Z',
                    adaptiveHeight: false,
                    draggable: false,
                    wrapAround: true,
                    resize: true,
                })

                carouselParllax($carousel, '.carousel-item')
                carouselCaptions($carousel)
            })
    }

    function eventFlickity() {
        if (!$('.event-carousel').get(0))
            return

        $('.event-carousel')
            .each(function(index, element) {
                let $carousel = $('.event-carousel')

                let options = {
                    cellAlign: 'right',
                    prevNextButtons: true,
                    pageDots: true,
                    arrowShape: 'M16.1.5,13.4,4.3l7.8,5.4H-.1v4.6H21.2l-7.8,5.4,2.7,3.8,13.8-9.6V10.1Z',
                    adaptiveHeight: window.innerWidth > 640,
                    wrapAround: true,
                    draggable: true,
                }

                $carousel.flickity(options)
            })
    }

    function autoFlickity() {
        if (!$('.auto-carousel-container').get(0))
            return

        $('.auto-carousel-container')
            .each(function(index, element) {
                let $carousel = $(element)

                $carousel.flickity({
                    cellSelector: '.auto-carousel-cell',
                    cellAlign: 'right',
                    pageDots: false,
                    wrapAround: element.children.length > 2,
                    autoPlay: true,
                    prevNextButtons: false,
                    draggable: false,
                    accessbility: false,
                    resize: true
                })

                carouselParllax($carousel, '.auto-carousel-cell')
                carouselCaptions($carousel);
            })
    }

    function carouselParllax(carousel, slideSelector) {
        var flkty = carousel.data('flickity')
        var $imgs = $(slideSelector + ' img', carousel)
        var slideCount = flkty.slides.length - 1

        carousel.on('scroll.flickity', function(event, progress) {
            flkty.slides.forEach( function( slide, i ) {
                var img = $imgs[i]
                var x = 0

                if (0 === i
                        && Math.abs( flkty.x ) > flkty.slidesWidth)
                    x = flkty.slidesWidth + flkty.x
                        + flkty.slides[slideCount].outerWidth + slide.target
                else if (i === slideCount
                        && Math.abs(flkty.x)
                            + flkty.slides[i].outerWidth < flkty.slidesWidth)
                    x = slide.target - flkty.slidesWidth + flkty.x
                        - flkty.slides[i].outerWidth
                else
                    x = slide.target + flkty.x

                if (img !== undefined)
                     img.style.transform = 'translateX( ' + x  * -.666 + 'px)'
            })
        })
    }

    function carouselCaptions(carousel) {
        if (!carousel.siblings('div.captions').get(0))
            return

        const flkty = carousel.data('flickity')
        const context = carousel.siblings('div.captions')
        const captions = carousel.siblings('div.captions').find('.caption')

        carousel.on('select.flickity', function(event) {
            captions.each(function(index, el) {
                $(el).removeClass('active-caption').removeClass('open')

                if ($(el).data('slide-index') === flkty.selectedIndex)
                    $(el).addClass('active-caption')
            })
        })
    }

    function accordion() {
        const toggles = Array.from(document.querySelectorAll('.accordion-toggle'))

        toggles
            .forEach((toggle) => {
                const label = toggle.getAttribute('aria-label')
                    || 'Show details'

                const labelExpanded = toggle
                    .getAttribute('data-aria-label-expanded')
                        || 'Hide details'

                const id = toggle.getAttribute('aria-controls')

                const el = id
                    && document.getElementById(id)

                if (!el)
                    return (toggle.disabled = true)

                toggle.addEventListener('click', (e) => {
                    const isExpand = toggle.getAttribute('aria-expanded')
                        !== 'true'

                    const itemOpenClassName = 'info-open'

                    toggle.setAttribute('aria-expanded', isExpand)

                    toggle.setAttribute('aria-label', isExpand
                        ? labelExpanded
                        : label)

                    toggle.parentElement.parentElement
                        .classList[isExpand ? 'add' : 'remove'](
                            itemOpenClassName)
                })
            })
    }

    //Function to reset any styles that may have been changed on screen resize
    function resetStyles() {
        if (device === 'desktop'
                && document.body.classList.contains('mobile'))
            document.body.classList.remove('mobile')

        if (device !== 'desktop'
                && !document.body.classList.contains('mobile'))
            document.body.classList.add('mobile')

        if ((prefersReducedMotion
                    && !document.documentElement.classList
                        .contains('prefers-reduced-motion'))
                || (!prefersReducedMotion
                    && document.documentElement.classList
                        .contains('prefers-reduced-motion')))
            document.documentElement.classList.toggle('prefers-reduced-motion')
    }

    //Create an event checker function that grabs the current value of the after pseudo class of the #js-mediaquery-reference <div>
    //Based on: http://seesparkbox.com/demos/css-content-check/index.html
    function checkMediaQuery() {
        if (mqSupport) {
            prevDevice = device

            device = window.getComputedStyle(mq, ':after')
                .getPropertyValue('content')
                .replace(/"/g, '')

            resetStyles()
        }

        if (!mqSupport)
            device = 'desktop'
    }

    function checkDevice() {
        //Set up event listeners tied to media queries
        mq.addEventListener('webkitTransitionEnd', checkMediaQuery, true)
        mq.addEventListener('MSTransitionEnd', checkMediaQuery, true)
        mq.addEventListener('oTransitionEnd', checkMediaQuery, true)
        mq.addEventListener('transitionend', checkMediaQuery, true)

        // Detect prefers-reduced-motion
        if ('matchMedia' in window) {
            const mediaPrefersReducedMotion = window
                .matchMedia('(prefers-reduced-motion: reduce)')

            prefersReducedMotion = mediaPrefersReducedMotion.matches

            mediaPrefersReducedMotion
                .addEventListener('change', (e) => {
                    prefersReducedMotion = e.matches

                    resetStyles()
                })
        }

        checkMediaQuery()
    }

    function isHamburgerMenuExpanded() {
        return document.body.classList
            .contains(hamburgerMenuExpandedClassname)
    }

    function hamburgerMenu() {
        if (!hamburgerMenuToggle)
            return

        let scrollY = 0

        const label = hamburgerMenuToggle.getAttribute('aria-label')
            || 'Show main navigation'

        const labelExpanded = hamburgerMenuToggle
            .getAttribute('data-aria-label-expanded')
                || 'Hide main navigation'

        const onToggle = (e) => {
            const isExpand = !isHamburgerMenuExpanded()

            hamburgerMenuToggle.setAttribute('aria-expanded', isExpand)

            hamburgerMenuToggle.setAttribute('aria-label', isExpand
                ? labelExpanded
                : label)

            if (isExpand) {
                scrollY = window.scrollY

                if (header) {
                    header.setAttribute('role', 'dialog')
                    header.setAttribute('aria-modal', true)
                }

                const isToolbarVertical = document.body.classList
                    .contains('toolbar-vertical')

                const isToolbarTrayOpen = document.body.classList
                    .contains('toolbar-tray-open')

                if (isToolbarVertical
                        && isToolbarTrayOpen) {
                    const trayToggle = document.body
                        .querySelector('.toolbar-icon-menu.trigger')

                    if (trayToggle) {
                        trayToggle.click()
                        hamburgerMenuToggle.focus()
                    }
                }

                if (toolbar)
                    toolbar.setAttribute('aria-hidden', true)

            }

            document.body.classList[isExpand ? 'add' : 'remove'](
                hamburgerMenuExpandedClassname)

            if (!isExpand
                    && scrollY) {
                window.scrollTo(0, scrollY)

                scrollY = 0

                if (header) {
                    header.removeAttribute('role')
                    header.removeAttribute('aria-modal')
                }

                if (toolbar)
                    toolbar.removeAttribute('aria-hidden')
            }
        }

        hamburgerMenuToggle.addEventListener('click', onToggle)

        document.addEventListener('keydown', (e) => {
            if (!isHamburgerMenuExpanded())
                return

            const isEsc = /escape/i.test(e.key || e.code)

            const isTab = /tab/i.test(e.key || e.code)

            if (isEsc
                    || !isTab
                    || !window.tabbable)
                return isEsc
                    && onToggle(e)

            const els = window.tabbable.tabbable(header)

            let activeEl

            if (e.shiftKey
                    && els.indexOf(e.target) === 0)
                activeEl = els[els.length - 1]

            if (!e.shiftKey
                    && els.indexOf(e.target) === els.length - 1)
                activeEl = els[0]

            if (!activeEl)
                return

            e.preventDefault()
            e.stopPropagation()

            activeEl.focus()
        })

        window.addEventListener('resize', (e) => {
            if (!hamburgerMenuToggle)
                return

            const isHamburgerToggleHidden = window
                .getComputedStyle(hamburgerMenuToggle)
                .display === 'none'

            if (isHamburgerToggleHidden
                    && isHamburgerMenuExpanded())
                onToggle(e)
        })
    }

    function submenuToggle() {
        const toggles = Array.from(document.querySelectorAll('.toggle--submenu'))

        toggles
            .forEach((toggle) => {
                const label = toggle.getAttribute('aria-label')
                    || 'Show submenu'

                const labelExpanded = toggle
                    .getAttribute('data-aria-label-expanded')
                        || 'Hide submenu'

                toggle.addEventListener('click', (e) => {
                    const menu = (toggle.nextElementSibling || {}).id
                            === toggle.getAttribute('aria-controls')
                        && (toggle.nextElementSibling || {}).children
                        && toggle.nextElementSibling

                    if (!menu)
                        return

                    const isExpand = toggle.getAttribute('aria-expanded')
                        !== 'true'

                    const itemOpenClassName = 'menu-item--is-open'

                    if (isExpand) {
                        const toggles = Array.from(
                            toggle.parentElement.parentElement
                                .querySelectorAll('button[aria-expanded=true]'))

                        toggles.forEach(el => el.click())
                    }

                    toggle.setAttribute('aria-expanded', isExpand)

                    toggle.setAttribute('aria-label', isExpand
                        ? labelExpanded
                        : label)

                    toggle.parentElement
                        .classList[isExpand ? 'add' : 'remove'](
                            itemOpenClassName)
                })
            })
    }

    function searchToggle() {
        const toggle = document.getElementById('desktop-search')

        const label = toggle.getAttribute('aria-label')
            || 'Show search'

        const labelExpanded = toggle
            .getAttribute('data-aria-label-expanded')
                || 'Hide search'

        const overlayForm = document.getElementById('search_form_container')

        const overlayFormCollapsedClassName = 'form-search-form--is-hidden'

        const headerOverlayFormExpandedClassName = 'form-search-form--is-visible'

        const onToggle = (e) => {
            const isClick = (e || {}).type === 'click'

            const searchPageInput = document.getElementById('gsc-i-id1')

            if (isClick
                    && searchPageInput)
                return searchPageInput.focus()

            const isExpand = overlayForm.classList
                .contains(overlayFormCollapsedClassName)

            toggle.setAttribute('aria-expanded', isExpand)

            toggle.setAttribute('aria-label', isExpand
                ? labelExpanded
                : label)

            toggle.classList[isExpand ? 'add' : 'remove']('is-close-button')

            overlayForm.classList[isExpand ? 'remove' : 'add'](
                overlayFormCollapsedClassName)

            header.classList[isExpand ? 'add' : 'remove'](
                headerOverlayFormExpandedClassName)

            const searchInput = overlayForm.querySelector('input[type=search]')

            if (isExpand
                    && searchInput)
                searchInput.focus({ preventScroll: true })
        }

        toggle.addEventListener('click', onToggle)

        document.addEventListener('keydown', (e) => {
            if (header.classList.contains(headerOverlayFormExpandedClassName)
                    && /escape/i.test(e.code))
                onToggle()
        })

        document.addEventListener('keyup', (e) => {
            if (header.classList.contains(headerOverlayFormExpandedClassName)
                    && !overlayForm.contains(e.target))
                onToggle()
        })

        window.addEventListener('scroll', (e) => {
            if (overlayForm.classList.contains(overlayFormCollapsedClassName)
                    || !header.classList.contains('offscreen')
                    || (header.classList.contains('sticky')
                        && !header.classList.contains('sticky--hide')))
                return

            onToggle()
        }, { passive: true })
    }

    function viewFilters() {
        let view = document.querySelector('.views-element-container .view')

        if (!view)
            return

        if ((view.classList.contains('view--name--upcoming-events')
                    || view.classList
                        .contains('view--name--current-season-events'))
                && view.classList.contains('bg--tan'))
            document.getElementById('page')
                .classList.add('bg--tan')

        view = view.parentElement

        let form

        let details

        let summary

        let results

        const getForm = () =>
            view.querySelector('form')

        const getDetails = () =>
            view.querySelector(
                'details.js-form-wrapper')

        const getDetailsSummary = () =>
            getDetails()
                && getDetails().querySelector('summary')

        const getResults = () =>
            getForm()
                && view.querySelector('.view-content > .views-rows')

        let isLoad = true

        let focusVisible = false

        const onInit = () => {
            form = getForm()

            if (!form)
                return

            details = getDetails()

            summary = getDetailsSummary()

            results = getResults()

            const checked = details
                && details.querySelector('input:checked')

            if (details) {
                if (details.open
                        && (!focusVisible
                            || !checked))
                    details.open = false

                if (details.open
                        && focusVisible
                        && checked)
                    checked.focus({ preventScroll: true })
            }

            if (summary) {
                summary.setAttribute('data-bef-auto-submit-exclude', true)
                summary.setAttribute('aria-expanded', details.open)
            }

            if (results) {
                const viewsHeader = view.querySelector('header')

                let resultsLabel = (viewsHeader || {}).innerText || ''

                resultsLabel = `Results${resultsLabel
                    ? ` for ${resultsLabel}`
                    : ''}`

                results.setAttribute('aria-label', resultsLabel)

                if (checked
                        && checked.value !== 'All')
                    results.setAttribute('aria-describedby', checked.id)

                results.tabIndex = '-1'

                if (!isLoad
                        && !view.contains(document.activeElement))
                    results.focus({ preventScroll: true })
            }

            isLoad = false

            focusVisible = false

            form.addEventListener('change', e => (
                focusVisible = Boolean(
                    details.querySelector('input:focus-visible'))))

            const detailsObserver = details
                && 'MutationObserver' in window
                && new window.MutationObserver(e => summary
                    && summary.setAttribute('aria-expanded', details.open))

            if (detailsObserver)
                detailsObserver.observe(details, {
                    attributes: true,
                    attributeFilter: ['open']
                })
        }

        onInit()

        const observer = 'MutationObserver' in window
            && new window.MutationObserver(e =>
                !view.contains(form)
                    && onInit())

        if (observer)
            observer.observe(view, {
                childList: true
            })

        document.addEventListener('click', (e) => {
            let details = getDetails()

            const isSummary = e.target === getDetailsSummary()

            if (isSummary
                    && details.open) {
                e.preventDefault()
                e.stopPropagation()
            }

            if (details
                    && details.open
                    && (e.target !== details
                        || !details.contains(e.target)
                        || isSummary))
                details.open = false
        })

        document.addEventListener('keyup', (e) => {
            let details = getDetails()

            if (details
                    && details.open
                    && (!details.contains(e.target)
                        || /escape/i.test(e.code)))
                details.open = false
        })
    }

    function addToCal() {
        const els = Array.from(document.querySelectorAll('.addtocalendar'))

        els
            .forEach((el) => {
                const toggle = el.querySelector('a.atcb-link')

                let list

                Array.from(el.children)
                    .forEach((_el) => {
                        if (list
                                && _el.classList.contains('atcb-list'))
                            el.removeChild(_el)

                        if (!list
                                && _el.classList.contains('atcb-list'))
                            list = _el
                    })

                if (!toggle
                        || !list)
                    return

                list.id = `${el.id}_list`

                toggle.setAttribute('aria-controls', list.id)

                toggle.tabIndex = 0

                const label = toggle.getAttribute('aria-label')
                    || 'Show'

                const labelExpanded = toggle
                    .getAttribute('data-aria-label-expanded')
                        || 'Hide'

                const isExpanded = () =>
                    toggle.getAttribute('aria-expanded')
                        === 'true'

                const onToggle = () => {
                    const isExpand = !isExpanded()

                    toggle.setAttribute('aria-expanded', isExpand)

                    toggle.setAttribute('aria-label', isExpand
                        ? labelExpanded
                        : label)
                }

                toggle
                    .addEventListener('click', (e) => {
                        e.preventDefault()

                        onToggle()
                    })

                toggle.addEventListener('keydown', (e) => {
                    if (!/^(space|enter)$/i.test(e.code))
                        return

                    e.preventDefault()
                    e.stopPropagation()

                    onToggle()
                })

                document.addEventListener('click', (e) => {
                    if (isExpanded()
                            && e.target !== toggle)
                        onToggle()
                })

                document.addEventListener('keyup', (e) => {
                    if (isExpanded()
                            && (!el.contains(e.target)
                                || /escape/i.test(e.code)))
                        onToggle()
                })
            })
    }

    /********************
     ** DOM Ready
     ********************/

    document.addEventListener('DOMContentLoaded', () => {
        //Check what device we're on
        if (mqSupport)
            checkDevice()

        hamburgerMenu()
        submenuToggle()
        searchToggle()
        flickity()
        autoFlickity()
        eventFlickity()
        accordion()
        viewFilters()
        addToCal()

        // Remove click functionality on pageDots
        $('.flickity-page-dots .dot')
            .on('pointerdown', function (e) {
                e.preventDefault()
                e.stopPropagation()
            })

        if (!(window._ || {}).debounce)
            return

        const resizeAttr = 'data-resizing'

        const resizeEl = document.documentElement

        window.addEventListener('resize', () =>
            resizeEl.getAttribute(resizeAttr) !== 'true'
                && resizeEl.setAttribute('data-resizing', true))

        const onResizeDebounce = window._.debounce(() =>
            resizeEl.removeAttribute(resizeAttr),
            200)

        window.addEventListener('resize', onResizeDebounce)

        const observer = 'MutationObserver' in window
            && new window.MutationObserver(() =>
                Array.from(document.querySelectorAll('img:not([alt])'))
                    .forEach(el => (el.alt = '')))

        if (observer)
            observer.observe(document.body, {
                childList: true,
                subtree: true
            })
    })

    //To understand behaviors, see https://drupal.org/node/756722#behaviors
    Drupal.behaviors.mann_theme_behavior = {
        attach: function(context, settings) {
            initBLazy()

            $('.view').bind("ajaxSuccess", function() {
                initBLazy()
            })

            // FormStack Forms
            $('.fsForm select', context)
                .wrap("<div class='select-wrapper'></div>")

            $('.fsForm input[type="checkbox"]', context)
                .after("<span class='checkbox'></span>")

            // Slideshow Captions
            $('.slideshow-wrapper .captions .caption', context)
                .on("click touchstart", function (e) {
                    e.preventDefault();
                    $(this).toggleClass('open');
                })
        }
    };
})(jQuery, Drupal, drupalSettings)
